import { useEffect } from "react";
import { useLocation } from "wouter";
import { useConsent } from "@/components/ConsentContext";

const GA_MEASUREMENT_ID = "G-20QH13RZ71";
const LIVE_HOSTS = new Set(["tts-britz.de", "www.tts-britz.de"]);
const GA_SCRIPT_ID = "britz-google-analytics";

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export default function GoogleAnalytics() {
  const [location] = useLocation();
  const { consent } = useConsent();
  const statisticsAllowed = consent?.statistics === true;

  useEffect(() => {
    (window as unknown as Record<string, boolean>)[`ga-disable-${GA_MEASUREMENT_ID}`] = !statisticsAllowed;

    if (!statisticsAllowed) return;
    if (!LIVE_HOSTS.has(window.location.hostname)) return;

    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer?.push(arguments);
    };

    if (document.getElementById(GA_SCRIPT_ID)) return;

    const script = document.createElement("script");
    script.id = GA_SCRIPT_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);

    window.gtag("js", new Date());
  }, [statisticsAllowed]);

  useEffect(() => {
    if (!statisticsAllowed) return;
    if (!LIVE_HOSTS.has(window.location.hostname)) return;
    if (!window.gtag) return;

    window.gtag("config", GA_MEASUREMENT_ID, {
      allow_ad_personalization_signals: false,
      allow_google_signals: false,
      page_title: document.title,
      page_location: window.location.href,
      page_path: location,
    });
  }, [location, statisticsAllowed]);

  return null;
}
